import { useMutation } from "react-query";
import http from "infra/http";

function useDeleteArrecadacao() {
  return useMutation(
    `/v1/arrecadacao/arrecadacaoId`,
    (data: {id: string; ano: number; mes: number; excluirTodas: number}) => http.delete(`/v1/arrecadacao/${data.id}/${data.mes}/${data.ano}?excluirTodas=${data.excluirTodas}`),
    { retry: false }
  );
}

export default useDeleteArrecadacao;
